module.exports = __webpack_public_path__ + "img/ru_failure_4.19a65222.png";